import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';

/**
 * CupExchangeModal — 圣杯兑换星币
 *
 * 规则（后台可配）：N 圣杯 = 1 星币（默认 22:1）
 * 用户指定想要的星币数 → 扣 N×星币 圣杯，永远整除。
 * GET  /taro/credits/cup-exchange  前置信息
 * POST /taro/credits/cup-exchange  执行兑换
 */
export default class CupExchangeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.submitting = false;
    this.coins = '';
    this.info = null;
    this.result = null;
    this.error = null;

    this.loadInfo();
  }

  className() {
    return 'TaroCupExchangeModal Modal--small';
  }

  title() {
    return '🏆 圣杯兑换星币';
  }

  loadInfo() {
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/credits/cup-exchange',
      })
      .then((r) => {
        this.info = r.data && r.data.attributes ? r.data.attributes : r.data;
        this.loading = false;
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        this.error = '加载失败，请稍后重试';
        m.redraw();
      });
  }

  onsubmit(e) {
    e.preventDefault();
    const coins = parseInt(this.coins, 10);
    if (!coins || coins <= 0) {
      this.error = '请输入有效的星币数量';
      m.redraw();
      return;
    }
    if (this.info && coins > this.info.maxExchangeable) {
      this.error = '最多可兑换 ' + this.info.maxExchangeable + ' 星币';
      m.redraw();
      return;
    }

    this.submitting = true;
    this.error = null;
    m.redraw();

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/taro/credits/cup-exchange',
        body: { data: { attributes: { coins } } },
      })
      .then((r) => {
        this.submitting = false;
        this.result = r.data && r.data.attributes ? r.data.attributes : r.data;
        m.redraw();
      })
      .catch((err) => {
        this.submitting = false;
        const detail = err && err.response && err.response.errors && err.response.errors[0];
        this.error = (detail && detail.detail) || '兑换失败，请稍后重试';
        m.redraw();
      });
  }

  content() {
    if (this.loading) {
      return <div className="Modal-body TaroCupExchange-loading">加载中…</div>;
    }

    if (this.result) {
      return (
        <div className="Modal-body TaroCupExchange-result">
          <div className="TaroCupExchange-successIcon">🎉</div>
          <p className="TaroCupExchange-successText">
            成功兑换 <b>{this.result.starCoinGained}</b> 星币
            <span className="TaroCupExchange-sub">（消耗 {this.result.cupCharged} 圣杯）</span>
          </p>
          <p className="TaroCupExchange-balance">
            当前余额：🏆 {this.result.balance.cup} 圣杯 · ⭐ {this.result.balance.star_coin} 星币
          </p>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" onclick={() => app.modal.close()}>
              完成
            </Button>
          </div>
        </div>
      );
    }

    const info = this.info || {};
    const rate = info.rate || 22;
    const coins = parseInt(this.coins, 10) || 0;
    const cupNeeded = coins * rate;

    return (
      <div className="Modal-body">
        <div className="TaroCupExchange-stats">
          <div className="TaroCupExchange-stat">
            <span className="TaroCupExchange-statValue">🏆 {info.cupBalance ?? '-'}</span>
            <span className="TaroCupExchange-statLabel">我的圣杯</span>
          </div>
          <div className="TaroCupExchange-stat">
            <span className="TaroCupExchange-statValue">{rate}:1</span>
            <span className="TaroCupExchange-statLabel">兑换汇率</span>
          </div>
          <div className="TaroCupExchange-stat">
            <span className="TaroCupExchange-statValue">{info.maxExchangeable ?? 0}</span>
            <span className="TaroCupExchange-statLabel">最多可兑星币</span>
          </div>
        </div>

        {info.benefitTotalCup > 0 && (
          <p className="TaroCupExchange-benefit">
            📈 累计内容分成收益：<b>{info.benefitTotalCup}</b> 圣杯（{info.benefitCount} 笔消费）
          </p>
        )}

        <form onsubmit={this.onsubmit.bind(this)}>
          <div className="Form-group">
            <label>要兑换的星币数量</label>
            <input
              type="number"
              className="FormControl"
              min="1"
              max={info.maxExchangeable || 0}
              value={this.coins}
              oninput={(e) => {
                this.coins = e.target.value;
              }}
              placeholder={'输入星币数'}
              disabled={this.submitting || (info.maxExchangeable || 0) === 0}
            />
            {coins > 0 && (
              <p className="TaroCupExchange-preview">
                将消耗 <b>{cupNeeded}</b> 圣杯 → 获得 <b>{coins}</b> 星币
              </p>
            )}
          </div>

          {this.error && <p className="TaroCupExchange-error">{this.error}</p>}

          <div className="Form-group">
            <Button
              type="submit"
              className="Button Button--primary Button--block"
              loading={this.submitting}
              disabled={this.submitting || coins <= 0 || (info.maxExchangeable || 0) === 0}
            >
              {(info.maxExchangeable || 0) === 0 ? '圣杯不足（需至少 ' + rate + ' 圣杯）' : '确认兑换'}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}
